import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { Button } from '@/components/ui/button';

interface SelectionToolbarProps {
  selectedCount: number;
  className?: string;
  classNameActions?: string;
  onClearSelection?: () => void;
  actions?: ReactNode;
}

export const SelectionToolbar: FC<SelectionToolbarProps> = ({
  selectedCount,
  className,
  classNameActions,
  onClearSelection,
  actions,
}) => {
  if (selectedCount <= 0) return null;

  return (
    <div
      className={cn(
        'flex w-full items-center gap-4 bg-[#E6F0FF] px-4 py-2 text-primary sm:px-10',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <div className={cn('flex items-center gap-20', classNameActions)}>
        <span className="relative pr-4 font-medium">
          Вибрано:{' '}
          <span className="absolute left-[calc(100%-12px)]">
            {selectedCount}
          </span>
        </span>
        {actions}
      </div>
      {onClearSelection && (
        <div className="ml-auto">
          <Button variant="ghost" size="sm" onClick={onClearSelection}>
            Скасувати вибір
          </Button>
        </div>
      )}
    </div>
  );
};

export default SelectionToolbar;
